// Simple event emitter for live update status
const listeners = [];

export function emitLiveUpdateStatus(status) {
  listeners.forEach((cb) => cb(status));
}

export function subscribeLiveUpdateStatus(cb) {
  listeners.push(cb);

  return () => {
    const idx = listeners.indexOf(cb);

    if (idx !== -1) listeners.splice(idx, 1);
  };
}
